import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '140px',
    height: 36,
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      marginLeft: 0
    },
    background: theme.palette.grey[300],
    borderRadius: 6,
    padding: 5
  },
  rootSmall: {
    height: 26,
    borderRadius: 4,
    padding: 2,
    margin: '4px 0px',
    width: '130px',
    background: theme.palette.background.default
  },
  button: {
    border: 8,
    width: 26,
    height: 26,
    borderRadius: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    '& svg': {
      fontSize: 20
    }
  },
  buttonSmall: {
    border: 4,
    width: 22,
    height: 22,
    '& svg': {
      fontSize: 14
    },
    background: theme.palette.grey[300]
  },
  countValue: {
    fontSize: 16,
    background: theme.palette.background.default,
    padding: '0px 10px',
    borderRadius: 14
  },
  countValueSmall: {
    fontSize: 10,
    padding: '0px 12px',
    background: theme.palette.background.default,
    borderRadius: 8
  },
  label: {
    color: theme.palette.text.secondary
  },
  circularProgress: {
    color: theme.palette.primary.main,
    alignSelf: 'center'
  }
}))

export default useStyles
